import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled SVG
 *
 * @param props - id, url, alt, width, height
 * @example
 * <SVG
 * 	id=""
 * 	url="https://www.example.com/image.svg"
 * 	alt="image of svg"
 * 	width="auto"
 * 	height="auto"
 * />
 * @reuturns JSX.Element
 */
var SVG = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
SVG.defaultProps = {};
var SampleProps = {
    id: "",
    url: "https://raw.githubusercontent.com/midasit-dev/moaui-fixed-repo/main/svg/midas_ci_mono_350_150.svg",
    alt: "image of svg",
    width: "350px",
    height: "150px",
};
export default SVG;
export { SampleProps as SVGSample, };
